export const fmtEUR = (v) =>
  v == null || isNaN(v) ? "—" : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);

export const fmtNum = (v, d = 2) =>
  v == null || isNaN(v) ? "—" : Number(v).toLocaleString("it-IT", { minimumFractionDigits: d, maximumFractionDigits: d });

export const fmtInt = (v) =>
  v == null || isNaN(v) ? "—" : Number(v).toLocaleString("it-IT", { maximumFractionDigits: 0 });

export const fmtPct = (v) =>
  v == null || isNaN(v) ? "—" : (v * 100).toLocaleString("it-IT", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + " %";

export const fmtRoas = (v) =>
  v == null || !isFinite(v) ? "—" : Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Parser tollerante per date: ISO pulita (2026-09-11), anno a 2 cifre in testa
// (26-09-08), giorno-first con anno a 2 cifre (12-09-26), già italiana (09/09/26).
// Euristica sui blocchi a 2 cifre: vince quello che forma un anno plausibile
// (2020-2035) — i dati sporchi storici della griglia rientrano in questi casi.
const _parseDataFlessibile = (s) => {
  if (!s || typeof s !== "string") return null;
  const t = s.trim();
  let m = t.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return [m[1], m[2], m[3]];
  m = t.match(/^(\d{2})-(\d{2})-(\d{2})$/);
  if (m) {
    const [, a, b, c] = m;
    if (2020 <= 2000 + +a && 2000 + +a <= 2035) return [`20${a}`, b, c];
    if (2020 <= 2000 + +c && 2000 + +c <= 2035) return [`20${c}`, b, a];
    return [`20${a}`, b, c];
  }
  m = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (m) {
    const anno = m[3].length === 2 ? `20${m[3]}` : m[3];
    return [anno, m[2].padStart(2, "0"), m[1].padStart(2, "0")];
  }
  return null;
};

// Data all'italiana gg/mm/aaaa per la lettura
export const fmtDataIT = (s) => {
  const p = _parseDataFlessibile(s);
  return p ? `${p[2]}/${p[1]}/${p[0]}` : s || "—";
};

// Sempre YYYY-MM-DD pulita: valore degli input type="date" (calendarietto)
export const isoData = (s) => {
  const p = _parseDataFlessibile(s);
  return p ? `${p[0]}-${p[1]}-${p[2]}` : "";
};
